import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { I18nextProvider } from 'react-i18next';
import i18n, { i18nReady } from './i18n/i18n';
import { App } from './App';
import { configureAmplify } from './aws-config';
import { isMockAuth, configureMockAuth } from './test-utils/mock-auth';
import './index.css';

// Configure auth: mock mode for local testing, Amplify for production
if (isMockAuth()) {
  configureMockAuth();
} else {
  configureAmplify();
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Don't retry auth errors
        if (error instanceof Error && error.message === 'Not authenticated') return false;
        return failureCount < 2;
      }
    }
  }
});

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

// Wait for non-English translation bundles to load before rendering
// so pages never flash English content
i18nReady.then(() => {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <BrowserRouter>
        <I18nextProvider i18n={i18n}>
          <QueryClientProvider client={queryClient}>
            <App />
          </QueryClientProvider>
        </I18nextProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
});
